export const formatPhoneNumber = (phoneNumber) => {
  // Format the phone number
  const formattedNumber = phoneNumber.replace(
    /(\d{2})(\d{4})(\d{4})/,
    "$1 $2 $3",
  );

  return formattedNumber;
};
